import styled from "styled-components";

const ChatDrawerWrapper = styled.div`
  height: 100%;
  
  .chat-list {
    border-right: 1px solid #e8e8ea;
    height: 100%;
    
    .chat-item {
      padding: 12px;
      transition: all 0.3s ease;

      //&.active {
      //  background-color: #f4fffc;
      //  border-radius: 6px;
      //}
    }   
  }

  .chat-active-header {
    padding: 20px 30px;
  }

  .chat-active-body {
    padding: 20px;
    border-top: 1px solid #E8E8EA;
    border-bottom: 1px solid #E8E8EA;
    height: 55vh;
    overflow: auto;
  }

  .send-icon {
    flex: none;
    margin: 10px 20px;
    width: 28px;
    height: 28px;
    background-color: #1BD2A4;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .chat-input {
    margin-top: 10px;
    height: 100%;
    border: none;
    outline:none;
    resize: none;
    box-shadow: none;
    padding: 1.25rem;

    &:focus-within {
      border: none;
      outline:none;
      box-shadow: none;
    }
  }
  .chat-message {
    background-color: #F9F9F9;
    padding: 0.5rem;
  }

  .chat-message .h-30 {
    height: 30em;
  }

  .chat-conversation::-webkit-scrollbar {
    width: 4px;
    cursor: pointer;
    /*background-color: rgba(229, 231, 235, var(--bg-opacity));*/
    width: 4px;
    cursor: pointer;
    /*background-color: rgba(229, 231, 235, var(--bg-opacity));*/
  }

  .chat-conversation::-webkit-scrollbar-track {
    background-color: rgba(229, 231, 235, var(--bg-opacity));
    cursor: pointer;
  }

  .chat-conversation::-webkit-scrollbar-thumb {
    cursor: pointer;
    background-color: #1bd2a4;
  }
  
  .chat-header {
    --tw-border-opacity: 1;
    border-color: rgb(232 232 234/var(--tw-border-opacity));
  }

  .mb-4 {
    margin-bottom: 1rem;
  }

  .py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .bg-message-owner {
    background-color: #E9FDF8;
    border-top-right-radius: 0.75rem;
    border-top-left-radius: 1.5rem;
    border-bottom-left-radius: 1.5rem;
  }

  .bg-message {
    background-color: #E8E8EA;
    border-bottom-right-radius: 1.5rem;
    border-top-right-radius: 1.5rem;
    border-top-left-radius: 0.75rem;
  }
  .text-xs {
    font-size: .75rem;
    line-height: 1rem;
  }
  .mr-1 {
    margin-right: 0.25rem;
  }
  .mr-2 {
    margin-right: 0.5rem;
  }
  .gap-2 {
    gap: 0.5rem
  }
  .gap-3 {
    gap: 0.75rem
  }
  .gap-4 {
    gap: 1rem
  }
  .gap-5 {
    gap: 1.25rem
  }
  .p-5 {
    padding: 1.25rem;
  }
  .p-4 {
    padding: 1rem;
  }
  .pt-5 {
    padding-top: 1.25rem;
  }
  
  .border-b-2 {
    border-bottom-width: 2px;
  }
  
  .chat-header {
    border-color: #E8E8EA;
  }
  
  .box-border {
    box-sizing: border-box;
  }
  
  .border-t-2 {
    border-top-width: 2px;
  }

  .chat-action {
    border-color: #E8E8EA;
  }
  
  .chat-sidebar {
    height: 590px;
  }
  
  .active {
    --tw-bg-opacity: 1;
    background-color: rgb(254 243 199/var(--tw-bg-opacity));
  }

  .scrollbar-hide {
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }

  .scrollbar-hide::-webkit-scrollbar {
    display: none;
  }
  
  .chat-avatar .ant-avatar-string {
    font-weight: bold;
    color: gray;
    textShadow: 2px 0 #fff, -2px 0 #fff, 0 2px #fff, 0 -2px #fff,
    1px 1px #fff, -1px -1px #fff, 1px -1px #fff, -1px 1px #fff;
  }
  
  .chat-content {
    white-space: pre-wrap;
  }
  
  .min-w-8 {
    min-width: 2.5rem;
  }

  .w-p-20 {
    width: 20%;
  }

  .w-p-60 {
    width: 60%;
  }
  .w-65 {
    width: 65px;
  }

  .separator {
    display: flex;
    align-items: center;
    text-align: center;
    --tw-text-opacity: 1;
    color: rgb(156 163 175/var(--tw-text-opacity));;
  }

  .separator::before,
  .separator::after {
    content: '';
    flex: 1;
    --tw-text-opacity: 1;
    border-bottom: 1px solid rgb(156 163 175/var(--tw-text-opacity));;
  }

  .separator:not(:empty)::before {
    margin-right: 1em;
  }

  .separator:not(:empty)::after {
    margin-left: 1em;
  }
}
`;

export { ChatDrawerWrapper };
